import { createSlice, current } from "@reduxjs/toolkit";
import { discountHelpers } from "@dotpe/rista-pos-common";
// ⚠️ Deep-imports the DESKTOP variant on purpose — ledger hazard 6. `userLogout`/
// `supportLogout` are web-only, and a bare `../LoginSlice` typechecks against `.native`.
import { supportLogout, userLogout } from "../LoginSlice";
import { sharedInitialState, sharedReducers } from "./shared";
import type { SharedDiscountState } from "./shared";

// Re-exported so `redux-store/slices/DiscountSlice` keeps exporting the type it always did.
export type { DiscountApprovalType } from "./shared";

export interface DiscountState extends SharedDiscountState {}

const initialState: DiscountState = {
  ...sharedInitialState,
};

export const discountSlice = createSlice({
  name: "discount",
  initialState,
  reducers: {
    ...sharedReducers,
    // ⚠️ Diverges from mobile: when the payload carries `OTPRequired`, web stamps
    // `isOtpRequired: true` onto every discount before storing. Mobile stores the payload
    // untouched (`state.discountInfo = action.payload`).
    applyDiscountSuccess: (state, action) => {
      const { OTPRequired, discounts } = action.payload ?? {};
      const updatedDiscounts = (OTPRequired && Array.isArray(discounts))
        ? discounts.map((discount: any) => ({ ...discount, isOtpRequired: true }))
        : discounts;
      state.discountInfo = {
        ...action.payload,
        discounts: updatedDiscounts,
      };
      state.isDiscountApplying = false;
    },
    // ⚠️ Same helper as mobile, different snapshot: web uses RTK's `current()` (a plain view
    // of the draft), mobile a `deepClone()`. Both feed `handleUpdateDiscountApproval`, but
    // `current()` returns a frozen structure while `deepClone` returns a mutable copy — do
    // not unify them without checking whether the helper writes to its argument.
    addDiscountApprovalData: (state, action) => {
      const discountApprovalData = current(state.discountApproval)
      state.discountApproval = discountHelpers.handleUpdateDiscountApproval(discountApprovalData, action.payload);
    },
  },
  // ⚠️ Both logout cases are EMPTY in the app and stay empty here — DiscountSlice does not
  // reset on logout. Preserved verbatim.
  extraReducers: (builder) => {
    builder
      .addCase(userLogout, (state) => {

      })
      .addCase(supportLogout, (state) => {

      });
  },
});

export const {
  applyDiscountApi,
  applyDiscountSuccess,
  applyDiscountFail,
  updateDiscountSlice,
  addDiscountApprovalData,
  checkDiscountStatus,
  updateDiscountClosed,
  setShowDiscountStatusModal,
  getExternalDiscounts
} = discountSlice.actions;
export default discountSlice.reducer;
